import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
export default function ConfirmDialog(props) {
  const { confirmDialog, setConfirmDialog } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={confirmDialog.isOpen}
      //   onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{confirmDialog.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {confirmDialog.subTitle}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={confirmDialog.onConfirm} color="primary">
          {t("Yes")}
        </Button>
        <Button
          onClick={() => setConfirmDialog({ ...confirmDialog, isOpen: false })}
          color="primary"
          autoFocus
        >
          {t("No")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
